import axios from 'axios';
import { client } from '@/services/api/axios.ts';
import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';

type TICreateFeedback = {
  type: string;
  description: string;
};

async function createFeedback({
  type,
  description,
}: TICreateFeedback): Promise<object | undefined | void> {
  try {
    const postPromise = client.post('/feedback', {
      type,
      description,
    });

    const { data } = await toast.promise(postPromise, {
      loading: 'Submitting feedback...',
      success: 'Feedback submitted successfully',
      error: (error) => {
        if (axios.isAxiosError(error)) {
          return error?.response?.data?.message || 'Failed to submit feedback';
        }
        return error instanceof Error ? error.message : 'Failed to submit feedback';
      },
    });

    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(`${error?.response?.data?.message}`);
    }

    if (error instanceof Error) {
      throw new Error(`${error.message}}`);
    }
  }
}

export const useCreateFeedbackQuery = ({ onSuccess }: { onSuccess?: () => void }) => {
  return useMutation({
    mutationFn: createFeedback,
    onSuccess: () => {
      if (onSuccess) onSuccess();
    },
  });
};
